export const ipfGUIPolicyKey = 'ipf-gui';
export const ipfGUIPolicyId = `vPolicies/${ipfGUIPolicyKey}`;

export const ipfGUIRoleKey = 'ipf-gui';
export const ipfGUIRoleId = `vRoles/${ipfGUIRoleKey}`;
